export default "__VITE_ASSET__C9nZ_4h4__"